"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _classnames2 = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var R = _interopRequireWildcard(require("ramda"));
var _Tooltip = _interopRequireWildcard(require("../../../../ui/Tooltip"));
var _styles = _interopRequireDefault(require("../../../styles"));
var _styles2 = _interopRequireDefault(require("../styles"));
var _styles3 = _interopRequireDefault(require("./styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var mapStopsaleToSeats = function mapStopsaleToSeats(stopsale) {
  return R.call(R.cond([[R.equals(-1), R.always('no')], [R.equals(0), R.always('request')], [R.T, R.always('yes')]]), stopsale);
};
var getClassNameBySeats = R.cond([[R.equals('request'), R.always(_styles.default.yellow)], [R.equals('no'), R.always(_styles.default.red)], [R.T, R.always('')]]);
var renderChildren = function renderChildren(children, $t) {
  return R.join(' ', [" + ".concat(children.length), $t('CHILD'), "(".concat(R.join(', ', children), ")")]);
};
var Food = function Food(_ref) {
  var className = _ref.className,
    compact = _ref.compact,
    food = _ref.food,
    foodFullName = _ref.foodFullName,
    informationOfCrossTour = _ref.informationOfCrossTour,
    isMobile = _ref.isMobile,
    room = _ref.room,
    stopsale = _ref.stopsale,
    people = _ref.people;
  var roomClassName = (0, _react.useMemo)(function () {
    return R.call(R.pipe(mapStopsaleToSeats, getClassNameBySeats), stopsale);
  }, [stopsale]);
  var _useTranslation = (0, _reactI18next.useTranslation)('PEOPLE_ABR'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames2.default)(_styles3.default.resultTourRoom, _styles2.default.resultTourCol, className, _defineProperty(_defineProperty({}, _styles3.default.compact, compact), _styles3.default.isMobile, isMobile))
  }, informationOfCrossTour ? /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    content: informationOfCrossTour,
    placement: _Tooltip.PLACEMENTS.TOP,
    trigger: [_Tooltip.TRIGGERS.HOVER]
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles3.default.combinedTours
  }, informationOfCrossTour)) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    content: foodFullName || food.toUpperCase(),
    placement: _Tooltip.PLACEMENTS.TOP,
    trigger: [_Tooltip.TRIGGERS.HOVER]
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles3.default.resultTourFood
  }, /*#__PURE__*/_react.default.createElement("strong", null, foodFullName || food.toUpperCase()))), /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    content: room,
    placement: _Tooltip.PLACEMENTS.TOP,
    trigger: [_Tooltip.TRIGGERS.HOVER]
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames2.default)(_styles3.default.resultTourRoomName, roomClassName)
  }, room))), people && /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    content: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "".concat(people.adults, " ").concat(t('ADULT')), !R.isEmpty(people.children) && renderChildren(people.children, t)),
    placement: _Tooltip.PLACEMENTS.TOP,
    trigger: [_Tooltip.TRIGGERS.HOVER]
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles3.default.resultTourists
  }, "".concat(people.adults, " ").concat(t('ADULT')), !R.isEmpty(people.children) && renderChildren(people.children, t))));
};
Food.propTypes = {
  food: _propTypes.default.string.isRequired,
  room: _propTypes.default.string.isRequired,
  stopsale: _propTypes.default.number.isRequired,
  className: _propTypes.default.string,
  foodFullName: _propTypes.default.string,
  informationOfCrossTour: _propTypes.default.string,
  isMobile: _propTypes.default.bool,
  people: _propTypes.default.shape({
    adults: _propTypes.default.number,
    children: _propTypes.default.arrayOf(_propTypes.default.number)
  })
};
var _default = exports.default = (0, _react.memo)(Food);